var map = {
	"./1.png": "550f",
	"./1g.png": "edf1",
	"./2.png": "0cca",
	"./2g.png": "620f",
	"./3.png": "5fd4",
	"./3g.png": "0234",
	"./4.png": "db83",
	"./4g.png": "a69c",
	"./5.png": "0d3a",
	"./5g.png": "e409",
	"./Asset 1.png": "83e6",
	"./Asset 1@2x.png": "e3a1",
	"./BG@3x.png": "fb6a",
	"./BG@3x@2x.png": "27cf",
	"./BG@3x@3x.png": "aa0a",
	"./Bar@3x.png": "cec3",
	"./Bar@3x@2x.png": "27f5",
	"./Bar@3x@3x.png": "868e",
	"./CN old.png": "e575",
	"./CN.png": "8ad5",
	"./Component 87 – 98.png": "e9e3",
	"./Component 87 – 98@2x.png": "d02d",
	"./Component.png": "c26b",
	"./Group 2831.png": "f4f9",
	"./Intersection 4.png": "61c5",
	"./Intersection 4@2x.png": "76e9",
	"./Intersection 4@3x.png": "95fc",
	"./Jarvis_Logo.png": "79f9",
	"./Jarvis_Logo@2x.png": "65ee",
	"./Jarviz-edit.png": "a75a",
	"./MM old.png": "1b7f",
	"./MM.png": "b84c8",
	"./Mask Group 130 w.png": "6770",
	"./Mask Group 98.png": "30c8",
	"./QR.png": "7f04",
	"./SeedAppIcon.png": "e22b",
	"./SeedAppiconWeb.png": "7b9a",
	"./SeedIcon.png": "e080",
	"./SeedIconM.png": "a652",
	"./SeedIconS.png": "4a7c",
	"./SeedLogo.png": "d47a",
	"./SignInImage.png": "d1ad",
	"./SignInImage@2x.png": "8f02",
	"./VN old.png": "ef5e",
	"./VN.png": "ce28",
	"./adminhomepage.png": "7643",
	"./announcment.png": "de30",
	"./app store.png": "0ae4",
	"./app store@2x.png": "46253",
	"./appicon.png": "2231",
	"./apple-iphone-1.png": "0edd",
	"./apple-iphone-1@2x.png": "84d6",
	"./bg-sildbar.png": "4ffe",
	"./check.png": "3c86",
	"./china.png": "db09",
	"./employee.png": "eac0",
	"./fb.png": "e265",
	"./google play.png": "131a",
	"./google play@2x.png": "f38d",
	"./ic_car.png": "ff9b",
	"./ic_car@2x.png": "aa3e",
	"./ic_car@3x.png": "fe44",
	"./ic_computer.png": "dfad",
	"./ic_computer@2x.png": "db8b",
	"./ic_computer@3x.png": "d8cd",
	"./ic_download.png": "5603",
	"./ic_download@2x.png": "0c52",
	"./ic_download@3x.png": "178b",
	"./ic_metting.png": "fa43",
	"./ic_metting@2x.png": "da42",
	"./ic_metting@3x.png": "0d1f",
	"./ic_office.png": "c242",
	"./ic_office@2x.png": "ba09",
	"./ic_office@3x.png": "955a",
	"./ic_printer.png": "93ef",
	"./ic_printer@2x.png": "a9a8",
	"./ic_printer@3x.png": "c6ab",
	"./ic_usa.png": "31a1",
	"./ic_usa@2x.png": "7d51",
	"./ic_usa@3x.png": "fc55",
	"./ic_user.png": "5eb7",
	"./ic_user@2x.png": "ec96",
	"./ic_user@3x.png": "81ae",
	"./image_loader.png": "fb1f",
	"./img-01.png": "e4cdf",
	"./img-01@2x.png": "cad9",
	"./img-01@3x.png": "c87a",
	"./img-02.png": "d3ae",
	"./img-02@2x.png": "e483",
	"./img-02@3x.png": "6d25",
	"./img-03.png": "86b1",
	"./img-03@2x.png": "d70d",
	"./img-03@3x.png": "ef7d",
	"./img-04.@2x.png": "57b6",
	"./img-04.@3x.png": "ef7f",
	"./img-04.png": "d0f3",
	"./img-avatar-01.png": "ff42",
	"./img-avatar-02.png": "bbd8",
	"./img-avatar-03.png": "579a",
	"./img-avatar-04.png": "a202",
	"./img-avatar-05.png": "ccb6",
	"./img-avatar-06.png": "f902",
	"./img-intersection.png": "122b",
	"./img-intersection@2x.png": "6a93",
	"./img-intersection@3x.png": "47d3",
	"./img-logo-01-v3.png": "4456",
	"./img-user-demo.png": "2829",
	"./jarvis-logo.png": "91ff",
	"./jarvis-logo@2x.png": "8a76",
	"./jarvis-logo@3x.png": "3018",
	"./leavesBg.png": "7375",
	"./lineimage.png": "0cae",
	"./logo.png": "ede7",
	"./logout.png": "0ade",
	"./mail.png": "7994",
	"./myanmar.png": "1c2c",
	"./register.png": "efac",
	"./registerimage1.png": "4dec",
	"./registerimage2.png": "598b",
	"./registerimage3.png": "ef63",
	"./registerimage4.png": "e2be",
	"./registerimage5.png": "a475",
	"./registrationcom.png": "9b24",
	"./sampleQRcode.png": "e5cc",
	"./seed_logo.png": "156a",
	"./seedadminlogo.png": "06f1",
	"./seedfirstlogo.png": "1b56",
	"./seedproductadminhome.png": "b28f",
	"./signin.png": "b284",
	"./th old.png": "1b19",
	"./th.png": "8062",
	"./thailand.png": "baa4",
	"./thumbnail_LOGO - Seed 2.png": "e6e2",
	"./uncheck.png": "25ca",
	"./united-kingdom.png": "7d59",
	"./us old.png": "be5d",
	"./us.png": "79fb",
	"./vietnam.png": "553c",
	"./warning.png": "6d29",
	"./—Pngtree—vector happy icon_4277917@2x.png": "03f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa71";